var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED5748;}\n\t.st1{fill:#FCC60E;}\n\t.st2{fill:#48B564;}\n\t.st3{fill:#2C85EB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.6,49.9c-18.9-10.9-43.2-4.4-54.1,14.5l-27.6,47.8c-8,13.8,2.3,18.6,13.8,25.5l26.6,15.3 c9,5.2,20.5,2.1,25.7-6.9L191.2,97C200.7,80.5,195.1,59.4,178.6,49.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.4,69.7l-26.6-15.3c-14.7-8.1-23-8.7-29,0.9l-39.2,67.8c-10.9,18.9-4.4,43.1,14.5,54 c16.5,9.5,37.6,3.9,47.1-12.6l39.9-69.1C159.4,86.4,156.3,74.9,147.4,69.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.5,34.8L133.8,24c-20.6-11.9-47-4.8-58.9,15.8l-35.5,61.5c-5.2,9.1-2.1,20.7,6.9,25.9l20.9,12.1 c10.3,6,23.5,2.4,29.5-7.9l40.6-70.2c8.4-14.5,27-19.5,41.6-11.1L152.5,34.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80,57.4L59.8,45.8c-9-5.2-20.5-2.1-25.7,6.9L10,94.5C-2,115,5.1,141.3,25.7,153.2l15.3,8.8l18.6,10.7l8.1,4.6 c-14.3-9.6-18.9-28.8-10.1-44l6.3-10.8L86.8,83C92,74.1,88.9,62.6,80,57.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.f5a64021a557a32197c43f2ef2e2aba7.svg";
export { ForwardRef as ReactComponent };